module.exports = __webpack_public_path__ + "static/img/strategic_layout.d1f914c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/strategic_layout.png
// module id = Q4n9
// module chunks = 32